import React from "react";
import Actualite, { ActualiteVideo } from "./Actualite";
import {
  faGraduationCap,
  faNewspaper,
} from "@fortawesome/free-solid-svg-icons";
import Titre from "../common/Titre";
import tem20 from "../../assets/video/tem(20).mp4";
import tem22 from "../../assets/video/tem(22).mp4";
import tem24 from "../../assets/video/tem(24).mp4";
import commite from "../../assets/video/actu_dame.mp4";
import actu from "../../assets/img/actu.jpg";
export default function ActualiteList() {
  const actualites = [
    {
      id: 4,
      img: { actu },
      titre: "Journes portes ouvertes",
      description:
        "Venez découvrir notre établissement et nos programmes lors de nos journées portes ouvertes.",
    }
  ];
  const actuvid = [
    {
      id: 0,
      video: commite,
      titre: "Une communauté inspirante",
      description:
        "Témoignages sur l'importance de notre réseau et des relations créées au sein de notre établissement.",
    },
    {
      id: 1,
      video: tem20,
      titre: "Un soutien constant",
      description:
        "Nos étudiants parlent de l'accompagnement et des ressources mises à leur disposition tout au long de leur parcours.",
    },
    {
      id: 2,
      video: tem22,
      titre: "Des compétences pour l'avenir",
      description:
        "Écoutez les retours de nos diplômés sur les compétences pratiques qu'ils ont acquises dans notre institution.",
    },
    {
      id: 3,
      video: tem24,
      titre: "Une communauté inspirante",
      description:
        "Témoignages sur l'importance de notre réseau et des relations créées au sein de notre établissement.",
    }

  ];


  return (
    <>
      <Titre
        children={"actualités"}
        icon={faNewspaper}
        soustitre={"Restez informés de toutes les nouvelles actualités."}
      />
      <div className="row justify-content-start">
        {actuvid.map((actualite) => (
          <ActualiteVideo key={actualite.id} actualite={actualite} />
        ))}

        {/* <Actualite actualite={actualites[0]} /> */}
      </div>


    </>
  );
}
